import { Plan } from '../plan';

export class Prompto extends Plan {
    public static readonly PLAN_TYPE = 'prompto_web';
}
